/**
 * Pagamento com Pagali Card (token SISP) — interruptor único.
 *
 * ACTIVO, incluindo produção. Homologado ponta-a-ponta a 29/07/2026: três
 * pagamentos concluídos pelo endpoint `bizmpi/TokenPayment` com HTTP 200 —
 * duas recargas Alou Móvel e um pagamento de factura EDEC.
 *
 * O que desbloqueou foi o fingerprint: o exemplo Java da Tokenização v1.1
 * inclui o token textual no hash, ao contrário do que o código assumia. Ver
 * `services/sisp/__tests__/fingerprint-token.test.ts` no backend.
 *
 * Ressalva conhecida: os sucessos foram todos em `transactionCode` 2 e 3
 * (pagamento de serviço e recarga). O `transactionCode` 6 — compra genérica,
 * usado pelo checkout da loja — nunca teve um pagamento concluído. Fica
 * activo por decisão de produto; se a loja falhar com o Pagali Card, é aí
 * que se olha primeiro.
 *
 * Não duplicar esta condição noutros ficheiros. Antes disto havia uma cópia
 * local no Checkout e nenhuma guarda no modal de pagamentos — era por isso
 * que o botão aparecia em produção sem que ninguém o tivesse decidido.
 */
export const ECARD_PAY_ENABLED = true;
